import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/ruler.svg';

const StatisticsBlock = {
  id: 'statistics',
  title: 'Statistic',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default StatisticsBlock;